module.exports = __webpack_public_path__ + "static/media/10ю09.e5461c22.webp";